import { CombinedStateCreator } from "../store";

export type CheckinsDisplayMode = "board" | "list";

export interface CheckinsStore {
  checkins: {
    displayMode: CheckinsDisplayMode;
    setDisplayMode: (displayMode: CheckinsDisplayMode) => void;
  };
}

export const createCheckinsStore: CombinedStateCreator<CheckinsStore> = (
  set,
) => ({
  checkins: {
    displayMode: "board",
    setDisplayMode: (displayMode) => {
      set((state) => {
        state.checkins.displayMode = displayMode;
      });
    },
  },
});
